import React from 'react';
import * as FaIcons  from 'react-icons/fa';

export const Relatoriocobranca=[
    {   icon:<FaIcons.FaWater/>,
        title:"Volume Consumido",
        link:"consumdo",
     

    },
    {    icon:<FaIcons.FaMoneyBill/>,
        title:"Montante Adquirido",
        link:"quantidade"

    },
    {
        icon:<FaIcons.FaBuyNLarge/>,
        title:"Volume adquirido",
        link:"adiquirido"

    },
    {
        icon:<FaIcons.FaPersonBooth/>,
        title:"Consumo total de Cliente",
        link:"consumo"

    },
    


]